<template>
  <div class="window-f-box">
    <ul class="metro">
      <li @click="go(item)" v-for="item in list" :key="item.name">
        <i class="iconfont" :class="item.icon"></i>
        <span>{{ item.name }}</span>
      </li>
    </ul>
  </div>
</template>
<script setup>
  // import { ref } from 'vue';
  import { useRouter } from 'vue-router'
  const router = useRouter()
  const list = [
    {
      name: 'Simulation',
      icon: 'icon-cube',
      url: '/scheduling/scheduling-schedulingIndex?name=simulation',
    },
    {
      name: '',
      icon: '',
      url: '',
    },
    {
      name: '',
      icon: '',
      url: '',
    },
    {
      name: '',
      icon: '',
      url: '',
    },
    {
      name: 'Scheduling',
      icon: 'icon-calendar',
      url: '/scheduling/scheduling-schedulingIndex?name=scheduling',
    },
  ]
  const go = (item) => {
    router.push(item.url)
  }
</script>
<style lang="less" scoped>
  @import './less/_window-f-box.less';
  .window-f-box .metro li:last-child {
    background: #5ca9d6;
  }
</style>
